import { Reveal, Overline } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMAGES } from "./data";

export const Workflow = () => {
  const { t } = useLanguage();
  return (
    <section id="workflow" data-testid="workflow-section" className="relative overflow-hidden py-24 lg:py-32">
      <img src={IMAGES.boardroom} alt="" aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.05]" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy/90 to-navy" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <Reveal><Overline>{t.workflow.overline}</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-slate-50 sm:text-4xl lg:text-5xl">
                {t.workflow.titleA} <span className="italic text-gold-gradient">{t.workflow.titleB}</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm leading-relaxed text-slate-400">{t.workflow.side}</p>
          </Reveal>
        </div>

        <div className="mt-16">
          {t.workflow.steps.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div data-testid={`workflow-step-0${i + 1}`}
                className="group grid gap-6 border-t border-navy-border py-10 transition-colors duration-500 hover:border-gold/40 lg:grid-cols-12 lg:gap-10 lg:py-14">
                <div className="lg:col-span-3">
                  <span className="font-serif text-6xl font-semibold text-transparent lg:text-8xl"
                    style={{ WebkitTextStroke: "1px rgba(212,175,55,0.55)" }}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="lg:col-span-5">
                  <h3 className="font-serif text-2xl font-medium leading-snug text-slate-100 transition-colors duration-300 group-hover:text-gold-pale lg:text-3xl">
                    {s.title}
                  </h3>
                  <p className="mt-4 leading-relaxed text-slate-400">{s.desc}</p>
                </div>
                <div className="flex flex-col justify-end lg:col-span-4">
                  <div className="border-l-2 border-gold/50 pl-5">
                    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{t.workflow.note}</span>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.details}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-navy-border" />
        </div>
      </div>
    </section>
  );
};
